import React, { useState, useEffect } from "react";
import { Form, Dropdown,Modal, Button, Card } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import { useNavigate } from "react-router-dom";
// import "./Admin.css";
import axios from "axios";
import { NotificationManager } from 'react-notifications';

const BaseUrl = process.env.REACT_APP_BASE_URL;

const CorporateClients = () => {
  const [search, setSearch] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [visiblePages, setVisiblePages] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [navQuantity, setNavQuantity] = useState("");
  const [navDate, setNavDate] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showNavDetailsModal, setShowNavDetailsModal] = useState(false);
  const [amount, setAmount] = useState('');
  const [showValidation, setShowValidation] = useState(false);
  

  const handleAssignNAV = (user) => {
    setSelectedUser(user);
    setShowModal(true); // Open modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close modal
    setNavQuantity(""); // Clear the fields
    setNavDate("");
  };

  const handleSave = () => {
    if (!navQuantity || !amount || !navDate) {
      setShowValidation(true); // Show validation messages
    } else {
      setShowValidation(false); // Reset validation
      handleSaveNAV(); // Proceed with saving
    }
  };

  const handleSaveNAV = async () => {
    try {
      // Make the API call to save NAV
      const response = await axios.post(`${BaseUrl}/corporate/nav`, {
        company_id: selectedUser.company_id,
        nav_date: navDate.toString().split("T")[0], // Format date as 'yyyy-MM-dd'
        nav_quantity: navQuantity,
        amount:amount
      });
      NotificationManager.success("NAV assigned successfully.");
      await fetchData();
      // Close modal after saving
      handleCloseModal();
    } catch (error) {
      // Handle error if the API call fails
      console.error("Error saving NAV:", error);
      alert("There was an error while saving NAV. Please try again.");
    }
  };


   // Define fetchData function within the component scope
   const fetchData = async () => {
    try {
      const token = getTokenFromLocalStorage(); // assuming this function exists
      if (!token) {
        navigate("/login");
        return;
      }
      if (!isAdmin()) { // assuming this function exists
        navigate("/login");
        return;
      }

      // Fetch corporate client data
      const response = await fetch(`${BaseUrl}/yasiraCorporateClients`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      // Parse nav_details into {date, quantity, price, amount}
      const usersWithNavDetails = data.map((user) => {
        if (user.nav_details) {
          const navDetails = user.nav_details.split(',').map((item) => {
            const [date, quantity, price, amount] = item.split(':');
            return {
              date,
              quantity: parseFloat(quantity),
              price: parseFloat(price),
              amount: parseFloat(amount) // Parse amount
            };
          });
          return { ...user, nav_details: navDetails };
        } else {
          return { ...user, nav_details: [] };
        }
      });


      // Update the state with the new data
      setFilteredUsers(usersWithNavDetails);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  // Fetch data when the component mounts
  useEffect(() => {
    fetchData();
  }, [BaseUrl]);

  // Handle closing the modal and refetch data
  const handleCloseNavDetailsModal = async () => {
    setShowNavDetailsModal(false);
    await fetchData();
};

    const handleViewNavDetails = async  (user) => {
        await fetchData();
        setSelectedUser(user);
        setShowNavDetailsModal(true);
      };
    
   
  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filtered = filteredUsers.filter(
      (user) =>
        user.name_of_institution.toLowerCase().includes(value) ||
        user.email.toLowerCase().includes(value)
        );
    setFilteredUsers(filtered);
    setCurrentPage(1); // Reset to first page on search
  };

  // Calculate total pages
  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);

  // Update visible pages based on current page
  const updateVisiblePages = () => {
    const startPage = currentPage;
    const endPage = Math.min(startPage + 2, totalPages);
    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    setVisiblePages(pages);
  };

  // Effect to update visible pages when currentPage changes
  useEffect(() => {
    updateVisiblePages();
    // eslint-disable-next-line
  }, [currentPage, filteredUsers, rowsPerPage]);

  // Function to handle page change
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Function to handle next page click
  const handlePaginationNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Function to handle previous page click
  const handlePaginationPrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Calculate the index range for current page
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, filteredUsers.length);

  // Slice users array based on current page
  const displayedUsers = filteredUsers.slice(startIndex, endIndex);

  // Function to handle rows per page change
  const handleRowsPerPageChange = (selectedRowsPerPage) => {
    setRowsPerPage(selectedRowsPerPage);
    setCurrentPage(1); // Reset to first page when rows per page changes
  };

  const getTokenFromLocalStorage = () => {
    const authData = localStorage.getItem("authToken");

    if (authData) {
      try {
        return authData;
      } catch (error) {
        console.error("Error parsing auth data:", error);
        return null;
      }
    } else {
      return null;
    }
  };

  const isAdmin = async () => {
    const token = getTokenFromLocalStorage();
    if (!token) {
      return false;
    }
    try {
      const response = await axios.post(`${BaseUrl}/validate-token`, { token });
      if (response.data.valid) {
        const decodedToken = decodeToken(token);
        return decodedToken.role === "admin";
      }
    } catch (error) {
      navigate("/");
      console.error("Error validating token:", error);
      return false;
    }
  };

  const decodeToken = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const decodedData = JSON.parse(atob(base64));
      return decodedData;
    } catch (error) {
      console.error("Error decoding token:", error);
      return {};
    }
  };

  return (
    <div className="cont">
      <div className="admin-management">
      <h3 style={{ fontWeight: 'bold' }}>CORPORATE CLIENTS</h3>
        <div className="table-search">
          <Form.Control
            type="text"
            placeholder="Search"
            value={search}
            onChange={handleSearchChange}
          />
        </div>
        <Card>
          <Card.Body className="table-card-body">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>NAME</th>
                    <th>EMAIL</th>
                    <th>NAV DETAILS</th>
                    <th>ACTION</th>
                     </tr>
                </thead>
                <tbody>
                  {displayedUsers.map((user) => (
                    <tr
                      key={user.company_id}
                     
                      style={{ cursor: "pointer" }}
                    >
                      {/* <td>{user.company_id}</td> */}
                      <td>{user.name_of_institution}</td>
                      <td>{user.email}</td>
                      <td>
                      {user.nav_details && user.nav_details.length > 0 ? (
                          <Button
                          variant="primary"
                          onClick={() => handleViewNavDetails(user)}
                        >
                          View NAV Details
                        </Button>
                      ) : (
                          <Button
                          variant="secondary"
                          disabled
                          > No NAV Details</Button>
                           )}
                    </td>
                     <td>
                        <Button
                          variant="primary"
                          onClick={() => handleAssignNAV(user)} // Pass user object
                        >
                          Assign NAV
                        </Button>
                      </td>
                      </tr>
                  ))}
                </tbody>
              </table>

                <Modal show={showModal} onHide={handleCloseModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>Assign NAV to {selectedUser?.name_of_institution}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      {/* NAV Quantity */}
                      <Form.Group controlId="navQuantity">
                        <Form.Label>NAV Quantity</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter NAV Quantity"
                          value={navQuantity}
                          onChange={(e) => setNavQuantity(e.target.value)}
                          isInvalid={showValidation && !navQuantity}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter a valid NAV Quantity.
                        </Form.Control.Feedback>
                      </Form.Group>
            
                      {/* Amount */}
                      <Form.Group controlId="amount">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter Amount"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          isInvalid={showValidation && !amount}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please enter a valid Amount.
                        </Form.Control.Feedback>
                      </Form.Group>
            
                      {/* Date */}
                      <Form.Group controlId="navDate">
                        <Form.Label>Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={navDate}
                          onChange={(e) => setNavDate(e.target.value)}
                          isInvalid={showValidation && !navDate}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please select a valid Date.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                      Close
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                      Save NAV
                    </Button>
                  </Modal.Footer>
                </Modal>

                 <Modal show={showNavDetailsModal} onHide={handleCloseNavDetailsModal}>
                            <Modal.Header closeButton>
                              <Modal.Title>NAV Details for {selectedUser?.name_of_institution}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              {/* Display NAV Details in a table format */}
                              {selectedUser?.nav_details && selectedUser.nav_details.length > 0 ? (
                                 <>
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th>Date</th>
                                      <th>Quantity</th>
                                      <th>Price</th>
                                      <th>Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {selectedUser.nav_details.map((detail, index) => (
                                      <tr key={index}>
                                        <td>{detail.date}</td>
                                        <td>{(detail.quantity).toLocaleString()}</td>
                                        <td>${detail.price}</td>
                                        <td>{detail.amount.toLocaleString()}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                                    <div style={{ marginTop: '10px', fontWeight: 'bold' }}>
                                    Total Quantity: {selectedUser.nav_details.reduce((total, detail) => total + detail.quantity, 0).toLocaleString()}
                                  </div>
                               </>
                              ) : (
                                <p>No NAV Details Available</p>
                              )}
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={handleCloseNavDetailsModal}>
                                Close
                              </Button>
                            </Modal.Footer>
                          </Modal>
                         </div>
            <div className="pagination-controls">
              <Dropdown>
                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                  {rowsPerPage}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleRowsPerPageChange(5)}>
                    5
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleRowsPerPageChange(10)}>
                    10
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleRowsPerPageChange(25)}>
                    25
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Pagination>
                <Pagination.Prev
                  onClick={handlePaginationPrev}
                  disabled={currentPage === 1}
                />
                {visiblePages.map((page) => (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => paginate(page)}
                  >
                    {page}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={handlePaginationNext}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
 
  );
};

export default CorporateClients;
